<script>
export default {
  name: 'ReservedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 40,
    },
    color: {
      type: String,
      default: '#02A0FC',
    },
    colorInternal: {
      type: String,
      default: '#02A0FC',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue
    // durante a vida da app). O id fixo original (copiado de export do Figma)
    // colide quando o mesmo ícone renderiza mais de uma vez na mesma página,
    // invalidando a máscara nas instâncias duplicadas.
    maskId() {
      return `mask0_7703_391361_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6667 26.6667C11.6667 25.75 12.4167 25 13.3333 25C14.25 25 15 25.75 15 26.6667C15 27.5833 14.25 28.3333 13.3333 28.3333C12.4167 28.3333 11.6667 27.5833 11.6667 26.6667ZM20 25H26.6667C27.5833 25 28.3333 25.75 28.3333 26.6667C28.3333 27.5833 27.5833 28.3333 26.6667 28.3333H20C19.0833 28.3333 18.3333 27.5833 18.3333 26.6667C18.3333 25.75 19.0833 25 20 25ZM30 33.3333H10C9.08167 33.3333 8.33333 32.585 8.33333 31.6667V21.6667H31.6667V31.6667C31.6667 32.585 30.9183 33.3333 30 33.3333ZM10 10H11.6667V11.6667C11.6667 12.5833 12.4167 13.3333 13.3333 13.3333C14.25 13.3333 15 12.5833 15 11.6667V10H25V11.6667C25 12.5833 25.75 13.3333 26.6667 13.3333C27.5833 13.3333 28.3333 12.5833 28.3333 11.6667V10H30C30.9183 10 31.6667 10.7483 31.6667 11.6667V18.3333H8.33333V11.6667C8.33333 10.7483 9.08167 10 10 10ZM30 6.66667H28.3333V5C28.3333 4.08333 27.5833 3.33333 26.6667 3.33333C25.75 3.33333 25 4.08333 25 5V6.66667H15V5C15 4.08333 14.25 3.33333 13.3333 3.33333C12.4167 3.33333 11.6667 4.08333 11.6667 5V6.66667H10C7.24333 6.66667 5 8.91 5 11.6667V31.6667C5 34.4233 7.24333 36.6667 10 36.6667H30C32.7567 36.6667 35 34.4233 35 31.6667V11.6667C35 8.91 32.7567 6.66667 30 6.66667Z"
      :fill="color"
    />
    <mask
      :id="maskId"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="5"
      y="3"
      width="30"
      height="34"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.6667 26.6667C11.6667 25.75 12.4167 25 13.3333 25C14.25 25 15 25.75 15 26.6667C15 27.5833 14.25 28.3333 13.3333 28.3333C12.4167 28.3333 11.6667 27.5833 11.6667 26.6667ZM20 25H26.6667C27.5833 25 28.3333 25.75 28.3333 26.6667C28.3333 27.5833 27.5833 28.3333 26.6667 28.3333H20C19.0833 28.3333 18.3333 27.5833 18.3333 26.6667C18.3333 25.75 19.0833 25 20 25ZM30 33.3333H10C9.08167 33.3333 8.33333 32.585 8.33333 31.6667V21.6667H31.6667V31.6667C31.6667 32.585 30.9183 33.3333 30 33.3333ZM10 10H11.6667V11.6667C11.6667 12.5833 12.4167 13.3333 13.3333 13.3333C14.25 13.3333 15 12.5833 15 11.6667V10H25V11.6667C25 12.5833 25.75 13.3333 26.6667 13.3333C27.5833 13.3333 28.3333 12.5833 28.3333 11.6667V10H30C30.9183 10 31.6667 10.7483 31.6667 11.6667V18.3333H8.33333V11.6667C8.33333 10.7483 9.08167 10 10 10ZM30 6.66667H28.3333V5C28.3333 4.08333 27.5833 3.33333 26.6667 3.33333C25.75 3.33333 25 4.08333 25 5V6.66667H15V5C15 4.08333 14.25 3.33333 13.3333 3.33333C12.4167 3.33333 11.6667 4.08333 11.6667 5V6.66667H10C7.24333 6.66667 5 8.91 5 11.6667V31.6667C5 34.4233 7.24333 36.6667 10 36.6667H30C32.7567 36.6667 35 34.4233 35 31.6667V11.6667C35 8.91 32.7567 6.66667 30 6.66667Z"
        fill="white"
      />
    </mask>
    <g :mask="`url(#${maskId})`">
      <rect :width="size" :height="size" :fill="colorInternal" />
    </g>
  </svg>
</template>
